import React from 'react'
import { Select } from 'antd'
import { CustomSelect } from 'src/components'
import { useTranslation } from 'next-i18next'
import { filteredOptions, getProjectOptionName } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { projectFormIsActiveSelector, projectOptionListSelector, setProjectFormItemValue } from 'src/features'
const { Option } = Select

const ProjectCertificationStatus: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isActive = useAppSelector(projectFormIsActiveSelector)
  const { data: projectOptions } = useAppSelector(projectOptionListSelector)
  const options = filteredOptions(projectOptions, 'status')

  return (
    <CustomSelect
      name='status'
      placeholder={t('Projects.Form.StatusPlaceholder')}
      onChange={(value: string) => dispatch(setProjectFormItemValue({ key: 'status', value }))}
      required={isActive}
    >
      {options.map(po => <Option key={po.id} value={getProjectOptionName(po)}>{getProjectOptionName(po)}</Option>)}
    </CustomSelect>
  )
}

export default ProjectCertificationStatus
